<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer007">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Chapter_One#_idTextAnchor000">CHAPTER ONE</a></p>
<p class="TOCitem"><span href="#/Chapter_Two#_idTextAnchor001" title="Link target outside of Sample">CHAPTER TWO</span></p>
<p class="TOCitem"><span href="#/Chapter_Three#_idTextAnchor002" title="Link target outside of Sample">CHAPTER THREE</span></p>
<p class="TOCitem"><span href="#/Chapter_Four#_idTextAnchor003" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="TOCitem"><span href="#/Chapter_Five#_idTextAnchor004" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="TOCitem"><span href="#/Chapter_Six#_idTextAnchor005" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="TOCitem"><span href="#/Chapter_Seven#_idTextAnchor006" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Eight#_idTextAnchor007" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="TOCitem"><span href="#/Chapter_Nine#_idTextAnchor008" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="TOCitem"><span href="#/Chapter_Ten#_idTextAnchor009" title="Link target outside of Sample">CHAPTER TEN</span></p>
<p class="TOCitem"><span href="#/Excerpt#_idTextAnchor010" title="Link target outside of Sample">EXCERPT FROM <em>TYCOON'S RING OF CONVENIENCE</em> BY JULIA JAMES</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?6b6d8748